import Checkbox from '@mui/material/Checkbox';
import styles from './CheckBox.module.scss';
import colors from '../../../../scss/colors';

function CheckBox({ selected, id, label, onChange, disabled, sx, labelSx }) {
  return (
    <div className={styles.checkboxParent}>
      <Checkbox
        onChange={onChange}
        className={styles.checkbox}
        id={id}
        sx={{
          '&.Mui-checked': {
            color: colors.LIGHT_BLUE
          },
          ...sx
        }}
        checked={selected}
        color="default"
        disabled={disabled}
      />
      <label className={`${styles.label} ${labelSx || ''} form-check-label`} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

export default CheckBox;
